import React from 'react';
import styled from 'styled-components';
import {
  // ShoppingCartOutlined,
  Check,
  CardGiftcardOutlined,
  FaceOutlined,
  Face3Outlined,
  Face4Outlined,
  Face5Outlined,
  DeleteOutline,
  Add,
  Close,
  SaveOutlined,
  Storefront,
  SettingsOutlined,
  ShoppingBasketOutlined,
  Foundation,
  Fingerprint,
  HomeOutlined,
  MeetingRoomOutlined,
  SupportAgent,
  Send,
  AutoStoriesOutlined,
  PersonAddAltOutlined,
  EngineeringOutlined,
  Insights,
  EditOutlined,
  NotificationsActiveOutlined,
  ArticleOutlined,
  PermMediaOutlined,
  AssignmentTurnedInOutlined,
  GroupsOutlined,
  QuizOutlined,
  EditOffOutlined,
  SelfImprovement,
  Search,
  LabelOutlined,
  AccessTime,
  EmailOutlined,
  ForwardToInboxOutlined,
  Link,
  ArrowBack,
  FolderOutlined,
  MoreHoriz,
  WorkspacePremium,
  ManageAccountsOutlined,
  FileDownloadOutlined,
  InfoOutlined,
  BoltOutlined,
  LockOutlined,
  LocalOfferOutlined,
  ReceiptLongOutlined,
  VideoFileOutlined,
  AudioFileOutlined,
  GroupAddOutlined,
  GridView,
  VisibilityOffOutlined,
  VisibilityOutlined,
  RocketLaunchOutlined,
  ContentCopy,
  UnpublishedOutlined,
  AdminPanelSettingsOutlined,
  DesignServicesOutlined,
  PostAdd,
  AssistantOutlined,
  CalculateOutlined,
  HistoryEdu,
  ScienceOutlined,
  LocalPoliceOutlined,
  IosShare,
  Done,
  PeopleAltOutlined,
  PersonOutlineOutlined,
  HighlightOffOutlined,
  SchoolOutlined,
  Facebook,
  ModeCommentOutlined,
  AttachFile,
  NavigateNext,
  InsertDriveFileOutlined,
  CreateNewFolderOutlined,
  FileUploadOutlined,
  Inventory2Outlined,
  UnarchiveOutlined,
  Sync,
  DangerousOutlined,
  CheckCircleOutlineOutlined,
  MapsUgcOutlined,
  DoNotDisturbAltOutlined,
  Reply,
  Devices,
  CalendarMonthOutlined,
  PictureAsPdfOutlined,
  List,
  Menu,
  ViewModule,
  PhotoSizeSelectActualOutlined,
  EditNote,
  Favorite,
  FavoriteBorder,
  KeyboardArrowRight,
  KeyboardArrowLeft,
  KeyboardArrowDown,
  KeyboardArrowUp,
  ContactSupport,
  KeyboardDoubleArrowRight,
  KeyboardDoubleArrowLeft,
  Preview,
  VolumeUp,
  VolumeOff,
  PlayArrow,
  Pause,
  Fullscreen,
  FullscreenExit,
  DragIndicator,
  TrendingUp,
  TrendingDown,
  LightbulbOutlined,
  OpenInNew,
  HubOutlined,
  Remove,
  AttachMoney,
  Adjust,
  Duo,
  AppRegistration,
  TextFormat,
  OndemandVideoOutlined,
  HeadphonesOutlined,
  PhotoLibraryOutlined,
  ForumOutlined,
  IntegrationInstructionsOutlined,
  FilterAltOutlined,
  ToggleOnOutlined,
  CampaignOutlined,
  StyleOutlined,
} from '@mui/icons-material';

const sizes = { 'x-small': '16px', small: '22px', medium: '28px', large: '42px', xxl: '100px' };

const SvgWrapper = styled.i`
  display: inline-flex;
  height: ${({ size }) => sizes[size] || sizes.medium};
  align-self: center;
  cursor: ${(props) => (props.$hoverEffectColor ? 'pointer' : 'normal')};
  &:hover {
    border-radius: 50%;
    background-color: ${(props) => props.$hoverEffectColor};
  }

  svg {
    width: ${({ size }) => sizes[size] || sizes.medium};
    height: ${({ size }) => sizes[size] || sizes.medium};
    fill: ${(props) => props.color || 'currentColor'};
  }
`;
const wrapIcon = (Component) => (props) =>
  (
    <SvgWrapper {...props}>
      <Component />
    </SvgWrapper>
  );

const Icon = {
  Check: wrapIcon(Check),
  Gift: wrapIcon(CardGiftcardOutlined),
  Cart: wrapIcon(ShoppingBasketOutlined),
  Person: wrapIcon(FaceOutlined),
  Person2: wrapIcon(Face5Outlined),
  Person3: wrapIcon(Face4Outlined),
  Person4: wrapIcon(Face3Outlined),
  Delete: wrapIcon(DeleteOutline),
  Add: wrapIcon(Add),
  Close: wrapIcon(Close),
  Save: wrapIcon(SaveOutlined),
  Storefront: wrapIcon(Storefront),
  Settings: wrapIcon(SettingsOutlined),
  Cancel: wrapIcon(HighlightOffOutlined),
  EditStore: wrapIcon(Foundation),
  ToggleOn: wrapIcon(ToggleOnOutlined),
  Fingerprint: wrapIcon(Fingerprint),
  Home: wrapIcon(HomeOutlined),
  Logout: wrapIcon(MeetingRoomOutlined),
  Support: wrapIcon(SupportAgent),
  Send: wrapIcon(Send),
  Users: wrapIcon(PeopleAltOutlined),
  Course: wrapIcon(AutoStoriesOutlined),
  Invite: wrapIcon(PersonAddAltOutlined),
  Insights: wrapIcon(Insights),
  Edit: wrapIcon(EditOutlined),
  Notifications: wrapIcon(NotificationsActiveOutlined),
  Notes: wrapIcon(ArticleOutlined),
  Media: wrapIcon(PermMediaOutlined),
  Task: wrapIcon(AssignmentTurnedInOutlined),
  Groups: wrapIcon(GroupsOutlined),
  Quiz: wrapIcon(QuizOutlined),
  EditOff: wrapIcon(EditOffOutlined),
  Yoga: wrapIcon(SelfImprovement),
  Search: wrapIcon(Search),
  Label: wrapIcon(LabelOutlined),
  Time: wrapIcon(AccessTime),
  Email: wrapIcon(EmailOutlined),
  Link: wrapIcon(Link),
  Back: wrapIcon(ArrowBack),
  Folder: wrapIcon(FolderOutlined),
  CreateFolder: wrapIcon(CreateNewFolderOutlined),
  More: wrapIcon(MoreHoriz),
  Certificate: wrapIcon(WorkspacePremium),
  Profile: wrapIcon(ManageAccountsOutlined),
  Download: wrapIcon(FileDownloadOutlined),
  Info: wrapIcon(InfoOutlined),
  Coupon: wrapIcon(LocalOfferOutlined),
  Bolt: wrapIcon(BoltOutlined),
  Lock: wrapIcon(LockOutlined),
  ExpandMore: wrapIcon(KeyboardArrowDown),
  ExpandLess: wrapIcon(KeyboardArrowUp),
  ArrowUp: wrapIcon(KeyboardArrowUp),
  ArrowDown: wrapIcon(KeyboardArrowDown),
  ArrowLeft: wrapIcon(KeyboardArrowLeft),
  ArrowRight: wrapIcon(KeyboardArrowRight),
  Receipt: wrapIcon(ReceiptLongOutlined),
  VideoFile: wrapIcon(VideoFileOutlined),
  AudioFile: wrapIcon(AudioFileOutlined),
  File: wrapIcon(InsertDriveFileOutlined),
  AddGroup: wrapIcon(GroupAddOutlined),
  Package: wrapIcon(GridView),
  VisibleOff: wrapIcon(VisibilityOffOutlined),
  Visible: wrapIcon(VisibilityOutlined),
  Published: wrapIcon(RocketLaunchOutlined),
  SendInvitation: wrapIcon(ForwardToInboxOutlined),
  InConstruction: wrapIcon(EngineeringOutlined),
  Copy: wrapIcon(ContentCopy),
  Valid: wrapIcon(CheckCircleOutlineOutlined),
  NotValid: wrapIcon(UnpublishedOutlined),
  Admin: wrapIcon(AdminPanelSettingsOutlined),
  CreateEdit: wrapIcon(DesignServicesOutlined),
  AddCourse: wrapIcon(PostAdd),
  Assistant: wrapIcon(AssistantOutlined),
  Accountant: wrapIcon(CalculateOutlined),
  Teacher: wrapIcon(HistoryEdu),
  Lab: wrapIcon(ScienceOutlined),
  Owner: wrapIcon(LocalPoliceOutlined),
  Export: wrapIcon(IosShare),
  Done: wrapIcon(Done),
  User: wrapIcon(PersonOutlineOutlined),
  Student: wrapIcon(SchoolOutlined),
  Facebook: wrapIcon(Facebook),
  AnswerUnread: wrapIcon(MapsUgcOutlined),
  Feedback: wrapIcon(ModeCommentOutlined),
  AttachFile: wrapIcon(AttachFile),
  Next: wrapIcon(NavigateNext),
  Upload: wrapIcon(FileUploadOutlined),
  Archive: wrapIcon(Inventory2Outlined),
  Unarchive: wrapIcon(UnarchiveOutlined),
  Play: wrapIcon(PlayArrow),
  Sync: wrapIcon(Sync),
  Wrong: wrapIcon(DangerousOutlined),
  DoNotDisturb: wrapIcon(DoNotDisturbAltOutlined),
  Reply: wrapIcon(Reply),
  Devices: wrapIcon(Devices),
  Calendar: wrapIcon(CalendarMonthOutlined),
  PDF: wrapIcon(PictureAsPdfOutlined),
  List: wrapIcon(List),
  Menu: wrapIcon(Menu),
  ViewModule: wrapIcon(ViewModule),
  Image: wrapIcon(PhotoSizeSelectActualOutlined),
  EditNote: wrapIcon(EditNote),
  Following: wrapIcon(Favorite),
  NotFollowing: wrapIcon(FavoriteBorder),
  Questions: wrapIcon(ContactSupport),
  DoubleArrowLeft: wrapIcon(KeyboardDoubleArrowLeft),
  DoubleArrowRight: wrapIcon(KeyboardDoubleArrowRight),
  Preview: wrapIcon(Preview),
  VolumeOn: wrapIcon(VolumeUp),
  VolumeOff: wrapIcon(VolumeOff),
  Pause: wrapIcon(Pause),
  FullscreenExit: wrapIcon(FullscreenExit),
  Fullscreen: wrapIcon(Fullscreen),
  DragIndicator: wrapIcon(DragIndicator),
  TrendingUp: wrapIcon(TrendingUp),
  TrendingDown: wrapIcon(TrendingDown),
  Lightbulb: wrapIcon(LightbulbOutlined),
  ExternalLink: wrapIcon(OpenInNew),
  Target: wrapIcon(Adjust),
  Network: wrapIcon(HubOutlined),
  Minus: wrapIcon(Remove),
  DollarSign: wrapIcon(AttachMoney),
  BarChart: wrapIcon(Insights),
  EditLayout: wrapIcon(AppRegistration),
  Webinar: wrapIcon(Duo),
  TextFormat: wrapIcon(TextFormat),
  Video: wrapIcon(OndemandVideoOutlined),
  Audio: wrapIcon(HeadphonesOutlined),
  PhotoLibrary: wrapIcon(PhotoLibraryOutlined),
  Forum: wrapIcon(ForumOutlined),
  Integration: wrapIcon(IntegrationInstructionsOutlined),
  Filter: wrapIcon(FilterAltOutlined),
  Campaign: wrapIcon(CampaignOutlined),
  SelectOption: wrapIcon(StyleOutlined),
};

Icon.displayName = 'Icon';

export default Icon;
